import React from 'react';
import { DTOrderSearchView } from '../../DTOrderSearchView';
import { processRbiOrderRefundItems } from '../../../../../../actions/tools/DecisionTree/RBIActions';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedOrder } from '../../../../../../selectors/tools';
import isEmpty from 'lodash/isEmpty';
import { OrderItemsSettingsContextProvider } from '../../Common/SearchResults/Common/DTOrderSearchResult/OrderItemsWrapper/OrderItemsSettingsContext';
import RBIItems from '../../Common/SearchResults/Common/DTOrderSearchResult/OrderItemsWrapper/RBIItems/RBIItems';

const DTSelectOrderRBIFullRefundNode = () => {
  const dispatch = useDispatch();
  const selectedOrder = useSelector(getSelectedOrder);

  const handleNextButtonClick = () => {
    dispatch(processRbiOrderRefundItems(true));
  };

  return (
    <OrderItemsSettingsContextProvider value={{ component: RBIItems, allSubItemsSelected: true }}>
      <DTOrderSearchView onNextButtonClick={handleNextButtonClick} isNextButtonActive={!isEmpty(selectedOrder)} />;
    </OrderItemsSettingsContextProvider>
  );
};

export default DTSelectOrderRBIFullRefundNode;
